import {useEffect, useRef, useState} from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const useComponentSize = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState({width: 0, height: 0});

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        const {width, height} = entries[0].contentRect;
        setSize({width, height});
      }
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return {ref, size};
};
